import { ICategoryRepresentation } from 'types/common';
import { ITemplate } from 'types/dto';
import { categories as categoryViewOptions } from 'utils/categories';

const fakeCategoryIds = ['inpp'];

export function useCategoryRepresentations(templates: ITemplate[] = [], noTemplates = false) {
  const categories = templates.reduce((categories, template) => {
    const categoryId = template.category.code.toLocaleLowerCase();

    if (!categories[categoryId]) {
      categories[categoryId] = {
        ...template.category,
        ...categoryViewOptions[categoryId],
        isFakeCategory: fakeCategoryIds.includes(categoryId),
        templates: noTemplates ? [] : [template],
      };
    } else {
      if (!noTemplates) {
        categories[categoryId].templates.push(template);
      }
    }
    return categories;
  }, {} as Record<string, ICategoryRepresentation>);

  return categories;
}
